<div class="gpd-tabbed-page">
  <nav class="gpd-page-tabs">
    <a *ngFor="let item of tabs" class="gpd-page-tab" [routerLink]="item.link" routerLinkActive="active">
      {{ item.text }}
    </a>
  </nav>
  <div class="gpd-tabbed-page-content folder-config-content">
    <router-outlet></router-outlet>
    <app-sandbox-folder-config *ngIf="sandboxEnabled" [context]="activeContext"></app-sandbox-folder-config>
  </div>
</div>
